export const Divider = ({
  thickness = 1,
  color = '#e5e7eb',
  marginTop = 10,
  marginBottom = 10,
  width = '100%'
}) => {
  return (
    <hr
      style={{
        height: thickness,
        backgroundColor: color,
        marginTop,
        marginBottom,
        width,
        border: 'none'
      }}
    />
  );
};
